<template>
	<div class="flex justify-center items-center" style="height: 100%">
		<div v-if="formattedSeoValue == 'loading'" class="sloader"></div>
		<!-- :color="getGradColor(101 - formattedSeoValue)" -->
		<vs-chip
			v-else
			:color="getGradColor(101 - formattedSeoValue)"
			style="font-size: 12px"
		>
			&nbsp;&nbsp;{{ formattedSeoValue }}&nbsp;&nbsp;
		</vs-chip>
	</div>
</template>
  
  <script>
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import utilsMixin from "@/mixins/utilsMixin.js";
export default {
	props: {
		value: {
			type: Number,
			default: null,
		},
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	data() {
		return {
			chooseNumber: 0,
		};
	},
	created() {
		console.log("value", this.$props.value);
		if (this.$props.value) {
			this.chooseNumber = Number(this.$props.value);
		} else {
			this.chooseNumber = (this.params && this.params.value) || "-";
		}
	},
	computed: {
		// Format the SEO value (multiplied by 100 and rounded)
		formattedSeoValue() {
			if (!isNaN(this.chooseNumber)) {
				// check if we have to conver to percent or not
				if (this.params && this.params.toPercent)
					return (Number(this.chooseNumber) * 100).toFixed(0);
				else return Number(this.chooseNumber).toFixed(0);
			}
			return this.chooseNumber;
		},
	},
	methods: {
		// Check if a value is a number

		// Determines the color based on the calculated value
		getGradColor(val) {
			if (val == 0) return "#C3C3C3"; // Default color if value is 0
			return this.gradientColor(val); // Get the gradient color
		},
		// Customize gradient color logic
	},
};
</script>
  
  <style scoped>
/* Optional custom styles here */
</style>
  